import { Monitor, Moon, Sun1 } from "iconsax-react-nativejs";
import { PresetTheme } from "../components/settings/appearance/preset-themes-section";
import { CustomColor } from "../components/settings/appearance/appearance";

export const PRESET_THEMES: PresetTheme[] = [
  { id: "default", name: "Default", color: "#0669B3" },
  { id: "sunset", name: "Sunset", color: "#ff512f" },
  { id: "abstract", name: "Abstract", color: "#4facfe" },
  { id: "dotted-indigo", name: "Indigo", color: "#667eea" },
  { id: "super-gradient", name: "Super", color: "#f953c6" },
  { id: "dotted-purple", name: "Purple", color: "#d299c2" },
  { id: "oranger", name: "Oranger", color: "#f7971e" },
  { id: "simple-pink", name: "Pink", color: "#fbc2eb" },
  { id: "lagoon", name: "Lagoon", color: "#2980b9" },
  { id: "dark-nature", name: "Nature", color: "#134e5e" },
  { id: "full-gradient", name: "Full Grad", color: "#f093fb" },
  { id: "sea-glass", name: "Sea Glass", color: "#4facfe" },
  { id: "blue-horizon", name: "Horizon", color: "#1a6dff" },
  { id: "sunrise", name: "Sunrise", color: "#f7971e" },
  { id: "aubergine", name: "Aubergine", color: "#7b2ff7" },
  { id: "barbra", name: "Barbra", color: "#ff416c" },
];

export const CUSTOM_COLORS: CustomColor[] = [
  { id: "primary-default", label: "Primary", hex: "#0669B3" },
  { id: "primary-1", label: "Primary light", hex: "#BAE0FD" },
  { id: "primary-2", label: "Primary wash", hex: "#EBF6FE" },
];

export const COLOR_MODES = [
  { id: "light", labelKey: "LABEL_LIGHT_MODE", icon: Sun1 },
  { id: "dark", labelKey: "LABEL_DARK_MODE", icon: Moon },
  { id: "system", labelKey: "LABEL_SYSTEM", icon: Monitor },
] as const;
